// A person's tasks with the biggest reward first (then the earliest due date). The Bounties tab shows
// only the top of this list, so the order decides which tasks are visible: lowest first would hide the
// ones that matter most.
export function byBountyHighestFirst(left, right) {
  return Number(right.bounty || 0) - Number(left.bounty || 0)
    || new Date(left.due_at || 0) - new Date(right.due_at || 0);
}
